import { visit } from 'unist-util-visit';
import type { Plugin } from 'unified';
import type { Root, Element } from 'hast';

/**
 * Rehype plugin to transform <chart> HTML elements into span elements
 * with data attributes that can be handled by the Chart component
 *
 * This plugin works after rehype-raw has parsed the HTML, transforming:
 * <chart type="candlestick" data_id="uuid" />
 * into:
 * <span data-chart="true" data-chart-type="candlestick" data-chart-id="uuid" />
 */
const rehypeChart: Plugin<[], Root> = () => {
  return (tree: Root) => {
    visit(tree, 'element', (node: Element) => {
      // Check if this is a <chart> element
      if (node.tagName === 'chart') {
        // Get the type and data_id attributes
        const chartType = node.properties?.type as string | undefined;
        const dataId = node.properties?.data_id as string | undefined;

        // Transform to a span with data attributes
        node.tagName = 'span';
        node.properties = {
          dataChart: true,
          dataChartType: chartType,
          dataChartId: dataId
        };
      }
    });
  };
};

export default rehypeChart;
